<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">广告信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <div style="width:500px">
          <el-form-item label="广告名称" prop="advName">
            <el-input v-model="form.advName" placeholder="请输入广告名称" style="width:100%;" />
          </el-form-item>
          <el-form-item label="广告类型" prop="advType">
            <el-radio-group v-model="form.advType" style="width:100%;" @change="changeClick">
              <el-radio :label="0">图片广告</el-radio>
              <el-radio :label="1">文字广告</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="isShow" label="广告内容" prop="advContent">
            <el-input v-model="form.advContent" type="textarea" :rows="4" placeholder="请输入广告内容" style="width:100%;" />
          </el-form-item>
          <el-form-item label="广告位置" prop="advLocation">
            <!-- 0:首页  1：加载页  2：充电 -->
            <el-select v-model="form.advLocation" placeholder="请选择广告位置" style="width:100%">
              <el-option v-for="item in adLocation" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="投放地域" prop="putArea">
            <STree v-model="form.putArea" :data="datatree" style="width:100%;" />
          </el-form-item> -->
          <el-form-item label="投放地域" prop="putArea">
            <div class="border">
              <el-input v-model="filterText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="tree"
                :data="datatree"
                show-checkbox
                node-key="id"
                :filter-node-method="filterNode"
                highlight-current
                :props="defaultProps"
                @check-change="handleCheckChange"
              />
            </div>
          </el-form-item>
          <!-- <el-form-item label="投放渠道" prop="putWay">
              <STree v-model="form.putWay" :data="datatree1" style="width:400px;"></STree>
            </el-form-item> -->
          <el-form-item label="广告主" prop="advEr">
            <el-input v-model="form.advEr" placeholder="请输入广告主" style="width:100%" />
          </el-form-item>
          <el-form-item v-if="!isShow" label="广告图片" prop="advPicture">
            <el-upload v-model="form.advPicture" class="avatar-uploader" :action="action" :headers="headers" style="width:100%" :show-file-list="false" :on-success="handleAvatarSuccess" :on-remove="handleRemove" :before-upload="beforeAvatarUpload" accept=".jpg, .jpeg, .png,">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <span v-if="imageUrl" class="el-upload-action" @click.stop="handleRemove()">
                <i class="el-icon-delete" />
              </span>
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
          </el-form-item>
          <el-form-item label="广告跳转" prop="adSelect">
            <el-radio-group v-model="form.urlType" style="width:400px;" @change="clickChangeUrl">
              <el-radio label="0" style="padding: 10px 0;">无跳转</el-radio>
              <el-radio label="1" style="padding: 10px 0;">活动</el-radio>
              <el-radio label="2" style="padding: 10px 0;">链接地址</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="showJumpUrl" label="链接地址" prop="jumpConnection">
            <el-input v-model="form.jumpConnection" placeholder="请输入链接地址" style="width:100%" />
          </el-form-item>
          <el-form-item v-if="showActivity" label="活动" prop="activityUrl">
            <el-select v-model="form.activityUrl" placeholder="请选择需要跳转的广告" style="width:100%">
              <el-option v-for="item in activityList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="投放时间" prop="date">
            <el-date-picker v-model="form.date" type="datetimerange" style="width:100%" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" :default-time="defaultTime" value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-form-item label="展示优先级" prop="showPriority">
            <el-input v-model="form.showPriority" style="width:100%" placeholder="请输入优先级" maxlength="2" @input="checkPriority" />
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import {
  HOST
} from '@/utils/host'
export default {
  name: 'Xinzengguanggao',
  components: {},
  data() {
    return {
      filterText: '', // 筛选树的关键字
      showJumpUrl: false,
      showActivity: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      pickerOptions: {
        disabledDate(time) {
          // let h = new Date().getHours();
          // let m = new Date().getMinutes();
          // let s = new Date().getSeconds();
          return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
        }
      },
      defaultTime: [],
      activityList: [],
      form: {
        advName: '',
        advType: 0,
        urlType: "0",
        activityUrl: '',
        date: [],
        jumpConnection: '',
        advPicture: '',
        advContent: ''
      },
      rules: {
        advName: [{
          required: true,
          message: '请输入广告名称',
          trigger: 'blur'
        }],
        advType: [{
          required: true,
          message: '请选择广告类型',
          trigger: 'blur'
        }],
        advContent: [{
          required: true,
          message: '请输入广告内容',
          trigger: 'blur'
        }],
        jumpConnection: [{
          required: true,
          message: '请输入链接地址',
          trigger: 'blur'
        }],
        activityUrl: [{
          required: true,
          message: '请绑定活动',
          trigger: 'blur'
        }],
        advLocation: [{
          required: true,
          message: '请选择广告位置',
          trigger: 'blur'
        }],
        advPicture: [{
          required: true,
          message: '请上传广告图片',
          trigger: 'blur'
        }],
        date: [{
          required: true,
          message: '请选择广告投放时间',
          trigger: 'blur'
        }]
      },
      datatree: [],
      datatree1: [],
      adLocation: [{
        value: '0',
        label: '首页'
      },
      {
        value: '1',
        label: '首页弹窗'
      },
      {
        value: '2',
        label: '充电界面'
      },
      {
        value: '3',
        label: '加载页广告'
      }
      ],
      isShow: false,
      imageUrl: ''
    }
  },
  computed: {
    // time(){
    //   let h = new Date().getHours();
    //   let m = new Date().getMinutes();
    //   let s = new Date().getSeconds();
    //   let time = h + ':' + m + ':' + s;
    //   console.log(time,44444)
    //   return {defaultTime : [h + ':' + m + ':' + s]}
    // },
    headers() {
      return {
        token: window.localStorage.getItem('token')
      }
    },
    action() {
      return HOST + '/oss'
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted() {
    this.getArea()
    // this.getOrg()
    this.getActivityList()
  },
  beforeMount() {
    console.log(new Date().getHours(), '小时', new Date().getMinutes(), new Date().getSeconds())
    const h = new Date().getHours()
    const m = new Date().getMinutes()
    const s = new Date().getSeconds()
    const time = h + ':' + m + ':' + s
    console.log(time, 2323)
    this.defaultTime.push(time)
  },
  methods: {
    filterNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    handleCheckChange(data, checked, indeterminate) {
      this.form.putArea = this.$refs.tree.getCheckedKeys()
    },
    checkPriority(_value) {
      _value = _value.replace(/^(0+)|[^\d]+/g, '')
      this.form.showPriority = _value
    },
    changeClick(val) {
      if (val === 0) {
        this.isShow = false
        this.adLocation = [{
        value: '0',
        label: '首页'
      },
      {
        value: '1',
        label: '首页弹窗'
      },
      {
        value: '2',
        label: '充电界面'
      },
      {
        value: '3',
        label: '加载页广告'
      }
        ]
        this.form.advContent = ''
      } else if (val === 1) {
        this.isShow = true
        this.adLocation = [{
        value: '0',
        label: '首页'
      },
      // {
      //   value: '1',
      //   label: '首页弹窗'
      // },
      {
        value: '2',
        label: '充电界面'
      }
      ]
        this.form.advPicture = ''
      }
      // this.form.advLocation = this.adLocation[0].value;
    },

    clickChangeUrl(val) {
      if (val === '0') {
        this.showJumpUrl = false
        this.showActivity = false
        this.form.jumpConnection = ''
        this.form.activityUrl = ''
      } else if (val === '1') {
        this.showJumpUrl = false
        this.showActivity = true
        this.form.jumpConnection = ''
      } else {
        this.showJumpUrl = true
        this.showActivity = false
        this.form.activityUrl = ''
        // this.form.jumpConnection = ''
      }
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.form.advPicture = res.data.fileName
    },
    handleRemove() {
      this.imageUrl = ''
      this.form.advPicture = ''
    },
    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')
      const isLt2M = file.size <= 2097152

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/JEPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },

    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }

      if (this.form.jumpConnection && this.form.jumpConnection !== '') {
        var strRegex = '((https?|ftp|file)://|www.)[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]'
        var re = new RegExp(strRegex)
        if (!re.test(this.form.jumpConnection)) {
          this.$message.error('链接地址格式错误!')
          return false
        }
      }
      if (this.form.urlType === '1') {
        if (!this.form.activityUrl || this.form.activityUrl === '') {
          this.$message.error('请选择分享活动!')
          return false
        }
      }
      if (!this.form.putArea || this.form.putArea.length < 1) {
        this.$message.error('请选择投放地域!')
        return false
      }
      const area = this.form.putArea.join(',')
      // let way = this.form.putWay.join(",")
      let jumpConnection = ''
      let activityType = ''
      if (this.form.urlType === '0') {
        jumpConnection = ''
      } else if (this.form.urlType === '1') {
        // 分享广告跳转地址
        const arr = this.form.activityUrl.split(',')
        jumpConnection = arr[0]
        activityType = arr[1]
      } else {
        // 普通跳转地址链接
        jumpConnection = this.form.jumpConnection
      }
      const data = {
        advName: this.form.advName,
        advType: this.form.advType,
        advContent: this.form.advContent,
        advLocation: this.form.advLocation,
        putArea: area,
        // putWay: way,
        putWay: '',
        advEr: this.form.advEr,
        jumpType: this.form.urlType,
        jumpConnection: jumpConnection,
        activityType: activityType,
        advPicture: this.form.advPicture,
        deliveryStart: this.form.date[0],
        deliveryEnd: this.form.date[1],
        showPriority: this.form.showPriority
      }
      this.$store.dispatch('form/handle', {
        url: '/business/advertising/put',
        data: data,
        method: 'put',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success'
          })
          this.$router.go(-1)
        }
      })
    },

    cancel() {
      this.$router.go(-1)
    },

    getArea() {
      this.$store.dispatch('form/handle', {
        url: '/business/advertising/getAreaTree',
        method: 'get',
        callback: resp => {
          this.datatree = resp
        }
      })
    },

    // getOrg() {
    //   this.$store.dispatch('form/handle', {
    //     url: '/business/advertising/getOrgTree',
    //     method: 'get',
    //     callback: resp => {
    //       this.datatree1 = resp
    //     }
    //   })
    // },
    getActivityList() {
      this.$store.dispatch('form/handle', {
        url: '/activity/page?pageSize=-1&pageNo=1&status=1,2&type=5,7',
        method: 'get',
        callback: resp => {
          console.log(resp)
          resp.list.forEach(element => {
            this.activityList.push({ 'label': element.name, 'value': element.id + ',' + element.type })
          })
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.el-upload-action {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 0;
  color: #fff;
  text-align: center;
  line-height: 120px;

}

.el-upload-action:hover {
  font-size: 20px;
  background-color: #000;
  background-color: rgba(0, 0, 0, .3)
}
.border{
  border: 1px solid #EEEEEE;
  padding: 20px;
  height: 300px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/adManagement/addAd.vue